import DesktopQuickFiltersBar from "./components/DesktopQuickFiltersBar";
import OfferFiltersMobile from "./components/OfferFiltersMobile";
import QuickFiltersBar from "./components/QuickFiltersBar";
import { OfferFiltersProvider } from "./context/OfferFiltersContext";
import React from "react";
export default function App({ lockedFinanceType = null, hiddenFilters = {} }) {
    return (<OfferFiltersProvider lockedFinanceType={lockedFinanceType} hiddenFilters={hiddenFilters}>
      <OfferFiltersMobile />
      <div className="lg:hidden">
        <QuickFiltersBar />
      </div>
      <div className="hidden lg:block">
        <DesktopQuickFiltersBar />
      </div>
    </OfferFiltersProvider>);
}
